import styled from 'styled-components';

import search_color from '../../assets/image/search/search-color.webp';
import search_color2x from '../../assets/image/search/search-color@2x.webp';
import search_color3x from '../../assets/image/search/search-color@3x.webp';

import arrow_left from '../../assets/image/arrow_left/arrow_left.webp';
import arrow_left2x from '../../assets/image/arrow_left/arrow_left@2x.webp';
import arrow_left3x from '../../assets/image/arrow_left/arrow_left@3x.webp';

import arrow_right from '../../assets/image/arrow_right/arrow_right.webp';
import arrow_right2x from '../../assets/image/arrow_right/arrow_right@2x.webp';
import arrow_right3x from '../../assets/image/arrow_right/arrow_right@3x.webp';

const search_list = [search_color, search_color2x, search_color3x];
const arrow_left_list = [arrow_left, arrow_left2x, arrow_left3x];
const arrow_right_list = [arrow_right, arrow_right2x, arrow_right3x];

export { search_list, arrow_left_list, arrow_right_list };

export const Container = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	//grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
	gap: 3rem;
	margin: 3rem auto;
	${({ theme }) => theme.device.tablet} {
		grid-template-columns: ${({ $fullWidth }) =>
			$fullWidth ? '1fr' : '3fr 1.2fr'};
	}
`;

export const DateAttendanceWrap = styled.div`
	//background-color: #7e84a3;
	${({ theme }) => theme.common.wh('100%')}
	${({ theme }) => theme.common.flex('column', 'flex-start', 'flex-start')}
`;

export const SearchFilterBar = styled.div`
	gap: 1rem;
	${({ theme }) => theme.common.wh('auto')}
	${({ theme }) => theme.common.flex('row', 'center', 'flex-start')}

	border-radius: 8px;

	div {
		border-radius: 8px;
		//border: solid 1px #dcdcdc;
		//background-color: #fff;
		opacity: 0.5;
		padding: 0.9rem;
	}

	img {
		filter: brightness(0.5);
	}

	select {
		box-sizing: border-box;
		height: 4rem;
		margin-bottom: 2rem;
		padding: 0 1rem;
		border: solid 1px #bcbcbc;
		border-radius: 8px;
		background-color: ${({ theme }) => theme.color.gray_ef};
	}
`;

export const SearchBar = styled.div`
	box-sizing: border-box;
	max-width: 20rem;
	gap: 0.5rem;
	background-color: ${({ theme }) => theme.color.gray_ef};
	border: solid 1px #bcbcbc;
	${({ theme }) => theme.common.wh('100%', '4rem')}
	${({ theme }) => theme.common.flex('row', 'center', 'space-between')}
	margin-bottom : 2rem;
	input {
		outline: none;
		border: none;
		background-color: transparent;
		${({ theme }) => theme.common.wh('100%')}
	}
`;

export const HeaderButton = styled.button`
	background-color: transparent;
	box-sizing: border-box;
	gap: 0.5rem;
	margin-bottom: 2rem;
	border: none;
`;

export const FilterBar = styled.div`
	max-width: 30rem;
	${({ theme }) => theme.common.wh('100%', '4rem')}
`;

export const Data = styled.div`
	border-top-left-radius: 16px;
	border-top-right-radius: 16px;
	padding: 0.9rem;
	padding-bottom: 2rem;
	position: relative;
	min-height: 6rem;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.08);
	//border: solid 2px #fed142;
	//background-color: ${({ theme }) => theme.color.lemon};
	background-color: #fff;
	${({ theme }) => theme.common.wh('100%', '5rem')}
	${({ theme }) => theme.common.flex()}
	
	span {
		font-family: NotoSansKR-Bold;
		font-size: 1.8rem;
		vertical-align: middle;
		margin-left: 3rem;
		margin-right: 3rem;
		color: ${({ theme }) => theme.color.gray_70};
		// border: solid 1px #fed142;
		// background-color: ${({ theme }) => theme.color.lemon};
	}

	button {
		cursor: pointer;
		& > div {
			display: flex;
			justify-content: center;
			flex-wrap: nowrap;
		}
		padding: 0.9rem;
		height: 100%;
		aspect-ratio: 1 / 1;
		border-radius: 8px;
		border: solid 1px #dcdcdc;
		margin: 0 1.2rem;
		background-color: transparent;
		${({ theme }) => theme.common.flex()}
		img {
			object-fit: fill;
		}
		&.month {
			margin: -0.5rem;
			padding: 0.5rem 1rem 0.5rem 1.5rem;
			img {
				margin-left: -0.5rem;
			}
		}

		&.privacy {
			top: 20%;
			right: 0;
			position: absolute;
			background-color: ${({ theme }) => theme.color.gray};
			width: fit-content;
			height: 60%;
			white-space: nowrap;
			font-weight: 600;
			&:hover {
				background-color: ${({ theme }) => theme.color.gray_90};
			}
		}

		&:disabled {
			opacity: 0.5;
			cursor: not-allowed;
		}
	}
`;

export const ButtonWrap = styled.div`
	margin-top: 2rem;
	${({ theme }) => theme.common.wh('100%', 'auto')}
	${({ theme }) => theme.common.flex('row', 'center', 'space-between')}
`;

export const AddButton = styled.button`
	background-color: #fff;
	height: 40px;
	//min-width: 15rem;
	border-radius: 1.2rem;
	border: solid 1px #dcdcdc;
	padding: 0.7rem 2rem;
	cursor: pointer;
	white-space: nowrap;
	&:hover {
		filter: brightness(0.7);
	}

	/* 툴팁 스타일 */
	&.privacy::after {
		content: '다운로드';
		position: absolute;
		bottom: 120%; /* 버튼 위쪽에 위치 */
		left: 50%;
		transform: translateX(-50%);
		background-color: rgba(0, 0, 0, 0.8);
		color: white;
		padding: 0.9rem 1.6rem;
		border-radius: 0.5rem;
		//font-size: 0.95rem;/**/
		font-weight: bold;
		white-space: nowrap;
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
		z-index: 1000;

		/* 말풍선 꼬리 */
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
	}

	/* 툴팁 화살표 */
	&.privacy::before {
		content: '';
		position: absolute;
		bottom: 105%; /* after보다 약간 아래 */
		left: 50%;
		transform: translateX(-50%);
		width: 0;
		height: 0;
		border-left: 5px solid transparent;
		border-right: 5px solid transparent;
		border-top: 5px solid rgba(0, 0, 0, 0.8);
		opacity: 0;
		visibility: hidden;
		transition: opacity 0.3s ease, visibility 0.3s ease;
		z-index: 1001;
	}

	/* 호버 시 툴팁 표시 */
	&.privacy:hover::after,
	&.privacy:hover::before {
		opacity: 1;
		visibility: visible;
	}
`;

export const Pagination = styled.div`
	${({ theme }) => theme.common.flex('row', 'center', 'space-between')}
`;

export const PageSizeSelector = styled.div`
	display: flex;
	position: relative;
	align-items: center;
	justify-content: center;
	gap: 2rem;
	margin-top: 1.5rem;
	margin-bottom: 1rem;
	padding: 0 1rem;
	width: 100%;

	.size-selector {
		position: absolute;
		right: 0;
		display: flex;
		align-items: center;
		gap: 0.8rem;

		label {
			font-size: 1.1rem;
			color: ${({ theme }) => theme.color.gray_70};
			font-weight: 600;
		}

		select {
			padding: 0.7rem 1.3rem;
			padding-right: 2.8rem;
			border: 2px solid #dcdcdc;
			border-radius: 8px;
			background-color: white;
			font-size: 1.1rem;
			font-weight: 500;
			color: ${({ theme }) => theme.color.gray_70};
			cursor: pointer;
			outline: none;
			transition: all 0.2s ease;
			background-image: url("data:image/svg+xml;charset=UTF-8,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='currentColor' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3e%3cpolyline points='6 9 12 15 18 9'%3e%3c/polyline%3e%3c/svg%3e");
			background-repeat: no-repeat;
			background-position: right 0.8rem center;
			background-size: 1.3rem;
			appearance: none;
			min-width: 110px;

			&:hover {
				border-color: #9ca3af;
				background-color: #f9fafb;
			}

			&:focus {
				border-color: ${({ theme }) => theme.color.gray_70 || '#4B5563'};
				box-shadow: 0 0 0 3px rgba(75, 85, 99, 0.1);
				background-color: white;
			}
		}

		.search-info {
			margin-left: 1rem;
			color: #6b7280;
			font-size: 1rem;
			font-weight: 500;
		}
	}
`;

export const InfoWrap = styled.div`
	margin-top: 5rem;
	gap: 1rem;
	${({ theme }) => theme.common.wh('100%')}
	${({ theme }) => theme.common.flex('column', 'center', 'space-between')}
`;
